const AdminNotificationPopup = () => {
    return (
        <>
            <div className="flex  gap-2.5 p-3 md:w-max items-start">
                <span className=" w-2 h-[13px] pt-[5px] pb-0 px-0">
                    <svg
                        fill="none"
                        height="8"
                        viewBox="0 0 8 8"
                        width="8"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="4" cy="4" fill="#9169F6" r="4" />
                    </svg>
                </span>
                <div className="flex flex-col gap-1 items-start">
                    <span className="font-normal text-[15px] font-helvetica text-[#0B1F35]">
                        New cash application from user!
                    </span>
                    <span className="font-normal text-[15px] text-[#B5B2B2] font-helvetica">
                        Today
                    </span>
                </div>
            </div>
        </>
    );
};

export default AdminNotificationPopup;
